export default __webpack_public_path__ + "static/media/2829 spice rack top.97a4fae1.png";